module.exports = __webpack_public_path__ + "static/s6-bg-e351b02b68d3599d0b0036e7b8e4612b.png";